import { message } from 'ant-design-vue'
import Vue from 'vue'
import Vuex from 'vuex'
import { hex_md5 } from './utils/md5.js'
import axios from "./plugins/axios.js"
import { createFormData, getSSRdata } from './utils/utils.js'
import { NULL_AVATAR } from './constant.js'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        username: "未登录",
        userid: -1,
        hasLogin: false,
        loginDialogVisible: false,
        resolve: null,
        avatarURL: NULL_AVATAR,
    },
    mutations: {
        login(state, { username, userid, avatarURL }) {
            state.hasLogin = true;
            state.userid = userid;
            state.username = username;
            state.avatarURL = avatarURL;
        },
        logout(state) {
            state.hasLogin = false;
            state.username = "未登录";
            state.userid = -1;
            state.avatarURL = NULL_AVATAR;
        },
        openLoginDialog(state, { resolve }) {
            state.resolve = resolve;
            state.loginDialogVisible = true;
        },
        closeLoginDialog(state) {
            state.loginDialogVisible = false;
            if (state.resolve) {
                state.resolve();
                state.resolve = null;
            }
        }
    },
    actions: {
        async openLoginDialog({ commit }) {
            await new Promise((resolve) => {
                commit("openLoginDialog", { resolve });
            })
        },
        async fetchUserInfo({ commit }) {
            const { data } = await axios.get("/backend/user/info.php");
            if (data.code == 0) {
                commit("login", data);
            }
        },
        async fetchSSRUserInfo({ commit }) {
            const data = getSSRdata("user");
            commit("login", data);
        },
        async doLogin({ commit }, form) {
            if (!form) return;
            const { data } = await axios.post("/backend/user/login.php", createFormData({
                nid: form.username,
                npass: hex_md5(form.password)
            }));
            if (data.code == 0) {
                commit("login", data);
                commit("closeLoginDialog");
            } else {
                message.error("登录失败");
            }
        }
    }
})

